/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Rafael De Jesus Molina Haeckermann                         ║
║ rafael.molina@est.iudigital.edu.co                         ║
╚════════════════════════════════════════════════════════════╝
*/
import * as React from "react";
import {
  Autocomplete,
  Box,
  Card,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import MDInput from "components/MDInput/index";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import colors from "assets/theme/base/colors";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

export default function ViewUserPerCard({
  isOpenModal,
  dataCarnet,
  handleCloseToModal,
  isDisabled,
  getFieldValue,
  typeCarnets,
}) {
  // Parsear custom_data si existe
  const customData = React.useMemo(() => {
    const customDataValue = getFieldValue("custom_data");

    if (!customDataValue) {
      return null;
    }

    try {
      // Si ya es un objeto, devolverlo directamente
      if (typeof customDataValue === "object" && customDataValue !== null) {
        return customDataValue;
      }
      // Si es un string, parsearlo
      if (typeof customDataValue === "string" && customDataValue.trim() !== "") {
        // Ignorar strings inválidos como "[object Object]"
        if (customDataValue === "[object Object]" || customDataValue.startsWith("[object")) {
          return null;
        }
        return JSON.parse(customDataValue);
      }
    } catch (error) {
      console.error("Error parsing custom_data:", error);
      return null;
    }

    return null;
  }, [getFieldValue]);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "700px",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
    maxHeight: "90vh",
  };
  const content = {
    margin: "0",
    padding: "0",
    display: "grid",
    align: "center",
    width: "100%",
    gridTemplateColumns: {
      xs: "repeat(auto-fit, minmax(200px, 1fr))",
      md: "repeat(2, 1fr)",
    },
    gap: "15px",
  };

  return (
    <>
      <Modal
        open={isOpenModal}
        onClose={handleCloseToModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Card sx={style}>
          <MDBox
            mt={-7}
            color="white"
            bgColor="info"
            variant="gradient"
            borderRadius="lg"
            p={2}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography id="modal-modal-title" component="h2">
              Detalles del usuario:
              <br />
              {` ${getFieldValue("name_user")} ${getFieldValue("last_name_user")}`}
            </Typography>

            <Icon
              sx={{
                fontSize: "2em",
                stroke: "currentColor",
                strokeWidth: "2px",
                cursor: "pointer",
                marginLeft: "auto",
              }}
              onClick={handleCloseToModal}
            >
              close
            </Icon>
          </MDBox>
          <Divider variant="middle" />
          <div style={{ maxHeight: "80%", overflowY: "auto", padding: "16px" }}>
            {/* Información básica */}
            <MDBox
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                },
                gap: 1.5,
                mb: 2,
              }}
            >
              <Box>
                <Typography variant="body2" color="text.secondary" fontWeight={500}>
                  Documento de identificación
                </Typography>
                <Typography variant="body2" color="black" fontWeight={400}>
                  {getFieldValue("number_id_user")}
                </Typography>
              </Box>

              <Box>
                <Typography variant="body2" color="text.secondary" fontWeight={500}>
                  Perfil
                </Typography>
                <Typography variant="body2" color="black" fontWeight={400}>
                  {getFieldValue("type_card")}
                </Typography>
              </Box>

              <Box>
                <Typography variant="body2" color="text.secondary" fontWeight={500}>
                  Tipo de sangre
                </Typography>
                <Typography variant="body2" color="black" fontWeight={400}>
                  {getFieldValue("blood_type")}
                </Typography>
              </Box>

              <Box>
                <Typography variant="body2" color="text.secondary" fontWeight={500}>
                  Correo electrónico
                </Typography>
                <Typography
                  variant="body2"
                  color="black"
                  fontWeight={400}
                  sx={{ wordBreak: "break-word" }}
                >
                  {getFieldValue("email_user")}
                </Typography>
              </Box>
              <Box>
                <Typography
                  id="modal-modal-description"
                  variant="body2"
                  color="text.secondary"
                  fontWeight={500}
                >
                  Condición especial
                </Typography>
                <Typography
                  variant="body2"
                  color="black"
                  fontWeight={400}
                  sx={{ wordBreak: "break-word" }}
                >
                  {getFieldValue("special_condition")}
                </Typography>
              </Box>
              <Box>
                <Typography
                  id="modal-modal-description"
                  variant="body2"
                  color="text.secondary"
                  fontWeight={500}
                >
                  Lugar de origen
                </Typography>
                <Typography
                  variant="body2"
                  color="black"
                  fontWeight={400}
                  sx={{ wordBreak: "break-word" }}
                >
                  {getFieldValue("origin_place")}
                </Typography>
              </Box>

              {getFieldValue("data_source") && (
                <Box>
                  <Typography variant="body2" color="text.secondary" fontWeight={500}>
                    Fuente de datos
                  </Typography>
                  <Typography variant="body2" color="black" fontWeight={400}>
                    {getFieldValue("data_source")}
                  </Typography>
                </Box>
              )}

              <Box>
                <Typography variant="body2" color="text.secondary" fontWeight={500}>
                  Estado
                </Typography>
                <Typography variant="body2" color="black" fontWeight={400}>
                  {getFieldValue("status")}
                </Typography>
              </Box>
            </MDBox>

            <Divider variant="middle" sx={{ my: 2 }} />

            {/* Fechas de vigencia */}
            <Typography variant="body2" color="black" fontWeight={500} mb={1.5}>
              Fecha de vigencia
            </Typography>
            <MDBox
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                },
                gap: 1.5,
                mb: 2,
              }}
            >
              <Box>
                <Typography variant="body2" color="text.secondary" fontWeight={500}>
                  Inicio
                </Typography>
                <Typography variant="body2" color="black" fontWeight={400}>
                  {new Date(getFieldValue("created")).toLocaleString("es-CO", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </Typography>
              </Box>

              <Box>
                <Typography variant="body2" color="text.secondary" fontWeight={500}>
                  Final
                </Typography>
                <Typography variant="body2" color="black" fontWeight={400}>
                  {new Date(getFieldValue("expired")).toLocaleString("es-CO", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </Typography>
              </Box>
            </MDBox>

            {/* Campos Personalizados (solo si existen) */}
            {customData && Object.keys(customData).length > 0 && (
              <>
                <Divider variant="middle" sx={{ my: 2 }} />
                <Typography variant="body2" color="black" fontWeight={500} mb={1.5}>
                  Información Adicional del Registro
                </Typography>
                <MDBox
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "repeat(2, 1fr)",
                    },
                    gap: 1.5,
                  }}
                >
                  {Object.entries(customData).map(([fieldId, fieldData]) => (
                    <Box key={fieldId}>
                      <Typography variant="body2" color="text.secondary" fontWeight={500}>
                        {fieldData?.label || fieldId}
                      </Typography>
                      <Typography variant="body2" color="black" fontWeight={400}>
                        {fieldData?.value || "N/A"}
                      </Typography>
                    </Box>
                  ))}
                </MDBox>
              </>
            )}
          </div>

          <Divider variant="middle" />
          <MDBox
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
            m={-0.5}
            mb={-2}
          >
            <MDButton color="error" onClick={handleCloseToModal}>
              Cerrar
            </MDButton>
          </MDBox>
        </Card>
      </Modal>
    </>
  );
}
